/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseColumnLayout } from './DatabaseColumnLayout';
import {
    DatabaseColumnLayoutFromJSON,
    DatabaseColumnLayoutFromJSONTyped,
    DatabaseColumnLayoutToJSON,
} from './DatabaseColumnLayout';

/**
 * 
 * @export
 * @interface DatabaseAppearancePropertiesDefaultViewColumns
 */
export interface DatabaseAppearancePropertiesDefaultViewColumns {
    /**
     * 
     * @type {DatabaseColumnLayout}
     * @memberof DatabaseAppearancePropertiesDefaultViewColumns
     */
    list?: DatabaseColumnLayout;
    /**
     * 
     * @type {DatabaseColumnLayout}
     * @memberof DatabaseAppearancePropertiesDefaultViewColumns
     */
    grid?: DatabaseColumnLayout;
    /**
     * 
     * @type {DatabaseColumnLayout}
     * @memberof DatabaseAppearancePropertiesDefaultViewColumns
     */
    gallery?: DatabaseColumnLayout;
    /**
     * 
     * @type {DatabaseColumnLayout}
     * @memberof DatabaseAppearancePropertiesDefaultViewColumns
     */
    details?: DatabaseColumnLayout;
}

/**
 * Check if a given object implements the DatabaseAppearancePropertiesDefaultViewColumns interface.
 */
export function instanceOfDatabaseAppearancePropertiesDefaultViewColumns(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearancePropertiesDefaultViewColumnsFromJSON(json: any): DatabaseAppearancePropertiesDefaultViewColumns {
    return DatabaseAppearancePropertiesDefaultViewColumnsFromJSONTyped(json, false);
}

export function DatabaseAppearancePropertiesDefaultViewColumnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearancePropertiesDefaultViewColumns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': !exists(json, 'list') ? undefined : DatabaseColumnLayoutFromJSON(json['list']),
        'grid': !exists(json, 'grid') ? undefined : DatabaseColumnLayoutFromJSON(json['grid']),
        'gallery': !exists(json, 'gallery') ? undefined : DatabaseColumnLayoutFromJSON(json['gallery']),
        'details': !exists(json, 'details') ? undefined : DatabaseColumnLayoutFromJSON(json['details']),
    };
}

export function DatabaseAppearancePropertiesDefaultViewColumnsToJSON(value?: DatabaseAppearancePropertiesDefaultViewColumns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': DatabaseColumnLayoutToJSON(value.list),
        'grid': DatabaseColumnLayoutToJSON(value.grid),
        'gallery': DatabaseColumnLayoutToJSON(value.gallery),
        'details': DatabaseColumnLayoutToJSON(value.details),
    };
}

